import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useJobManagerTranslations = () => useTranslationInterface('jobManager');
